export const documentTypes = {
  driverLicense: 1,
  vehicleLicensePlate: 2,
  passport: 3,
};
